import { SettingRow } from "./SettingRow";

export function SettingsSection({ title, data, updateSetting, resetSetting }) {
  return (
    <div className="settings-card">
      <div className="settings-card-header">
        <h2>{title.replaceAll("_", " ").toUpperCase()}</h2>
      </div>

      <div className="settings-columns">
        <div>SETTING</div>
        <div>DEFAULT VALUE</div>
        <div>CURRENT VALUE</div>
        <div>STATUS</div>
        <div>ACTION</div>
      </div>

      {Object.entries(data).map(([key, option]) => (
        <SettingRow
          key={key}
          settingKey={key}
          option={option}
          section={title}
          updateSetting={updateSetting}
          resetSetting={resetSetting}
        />
      ))}
    </div>
  );
}
